/** @deprecated */
export { HighlightPrice as default } from "../../badges/HighlightPrice";
